module.exports = __webpack_public_path__ + "img/doctor_list_logo.fdf82ed2.png";